<script lang="ts">
  import type { Product } from '../types';
  import { formatCurrency } from '../utils/format';
  import ProductDetailModal from './ProductDetailModal.svelte';

  interface Props {
    product: Product;
  }

  let { product }: Props = $props();
  let showModal = $state(false);

  function openModal() {
    showModal = true;
  }

  function closeModal() {
    showModal = false;
  }
</script>

<div
  class="bg-white rounded-lg shadow-sm border border-gray-200 p-2 hover:shadow-md transition-shadow cursor-pointer"
  onclick={openModal}
  role="button"
  tabindex="0"
  onkeypress={(e) => e.key === 'Enter' && openModal()}
>
  {#if product.image_url}
    <img
      src={product.image_url}
      alt={product.name}
      class="w-full h-20 object-cover rounded mb-2"
    />
  {:else}
    <div class="w-full h-20 bg-gray-200 rounded mb-2 flex items-center justify-center">
      <svg
        class="w-8 h-8 text-gray-400"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
        />
      </svg>
    </div>
  {/if}

  <h3 class="font-semibold text-gray-900 text-sm mb-1 line-clamp-2">{product.name}</h3>

  <div class="flex items-center justify-between mt-2">
    <span class="text-base font-bold text-primary-600">
      {formatCurrency(product.price)}
    </span>
    {#if product.item_code}
      <span class="text-xs text-gray-500">{product.item_code}</span>
    {/if}
  </div>
</div>

<ProductDetailModal product={showModal ? product : null} onClose={closeModal} />

